import React, { Component } from 'react';
import './Home.css';

//Firebase
import 'firebase/firestore';

//Components
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import ShowcaseRight from '../Components/ShowcaseRight';

//Data
import { generalfeatures } from '../Data/generalfeatures';

class Home extends Component {

  render() {
    window.scrollTo(0, 0)
    return (
      <main className="home header-offset">
        <Header/>
        <ShowcaseRight 
        showcase={generalfeatures}
        // download={true}
        />
        <Footer/>
      </main>
    );
  }
}

export default Home;




// WEBPACK FOOTER //
// ./src/Pages/Home.js